let flagCache: Record<string, boolean> | null = null;

/** Called by Root.tsx to populate the cache from the RTK Query response. */
export function setFeatureFlags (flags: Record<string, boolean>): void {
  flagCache = flags;
}

/** Reset the cache to null. Exported for test isolation only. */
export function resetFeatureFlags (): void {
  flagCache = null;
}

/** Returns whether a flag is enabled. Returns false if cache is not yet populated. */
export const isFeatureEnabled = (flagName: string): boolean => {
  if (flagCache) {
    return flagCache[flagName] ?? false;
  }
  return false;
};
